var _circle, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullEditFacial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#A0CFDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1255 6.16079C14.1451 8.52052 16.8858 9.609 19.2475 8.58858",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8163 14.7091C15.7967 12.3493 16.8825 9.60758 19.2441 8.58716",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3077 8.46778C34.9912 10.174 40.4461 17.3173 39.8168 25.3905C39.1276 34.2329 31.4007 40.8423 22.5583 40.1531C13.7159 39.4639 7.10646 31.737 7.79569 22.8946C8.25761 16.9685 11.8806 12.0453 16.882 9.65002L17.7247 9.17155",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9268 16.7812C22.9268 21.8057 18.8546 25.878 13.8301 25.878C18.8546 25.878 22.9268 29.9502 22.9268 34.9747C22.9268 29.9502 26.999 25.878 32.0235 25.878C26.999 25.878 22.9268 21.8057 22.9268 16.7812Z",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5526 14.5981C29.5526 16.4504 28.0514 17.9515 26.1992 17.9515C28.0514 17.9515 29.5526 19.4527 29.5526 21.305C29.5526 19.4527 31.0538 17.9515 32.9061 17.9515C31.0538 17.9515 29.5526 16.4504 29.5526 14.5981Z",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullEditFacial);
export default __webpack_public_path__ + "static/media/full-edit-facial.0bac0af9c2ce523627146c8d5ab3be20.svg";
export { ForwardRef as ReactComponent };